import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { checkRequestedChatNowAvailability, Types } from "actions/twilio-chat";
import { selectors } from "reducers";
import { browserHistory } from "browser-history";
import sound from "../../assets/sound.wav";
import "./styles.scss";
import { errorMessage } from "actions/message";

const ChatNow = ({ chatQueues }) => {
  const dispatch = useDispatch();
  const openChat = useSelector(selectors.getChatIsOpen);
  const requestedChatNowAvailability = useSelector(selectors.getRequestedChatNowAvailabilityInfo)
  const [blink, setBlink] = useState(false);
  const [channel, setChannel] = useState("");

  useEffect(() => {
    if (chatQueues && chatQueues.chat_pending) {
      if (chatQueues.channel_sid !== channel) {
        setBlink(true);
        setChannel(chatQueues.channel_sid);
        const audio = new Audio(sound);
        audio.play().catch(() => {});
      }
    } else {
      setBlink(false);
      setChannel("");
    }
  }, [chatQueues, channel]);

  useEffect(() => {
    dispatch({
      type: Types.REQUESTED_CHAT_NOW_AVAILABILITY_RESULT,
      payload: {}
    });
    if (openChat) dispatch({ type: Types.CLOSE_TWILIO_CHAT, keepOpen: false });
  }, []);

  useEffect(() => {
    if (requestedChatNowAvailability && requestedChatNowAvailability.channelId !== undefined) {
      if (requestedChatNowAvailability.channelId === chatQueues?.channel_sid) {
        if (requestedChatNowAvailability.result) {
          dispatch({ type: Types.START_TWILIO_CHAT, payload: requestedChatNowAvailability.channelId });
          browserHistory.push(`/patients/${chatQueues.patient_id}`);
        }
        else{
          dispatch(errorMessage("Chat Now Was Assigned to a different user"));
          setBlink(false)
        }
        dispatch({ type: Types.REQUESTED_CHAT_NOW_AVAILABILITY_RESULT, payload: {}});
      }
    }
  }, [requestedChatNowAvailability, chatQueues]);

  return (
    <>
      {blink && (
        <button
          style={{
            marginRight: "3%",
            borderRadius: 10
          }}
          className="blink_me"
          onClick={() => {
            dispatch(checkRequestedChatNowAvailability(chatQueues.channel_sid));
            setBlink(false);
          }}
        >
          Incoming Chat with {chatQueues.patient_first_name}{" "}
          {chatQueues.patient_last_name}{" "}
        </button>
      )}
    </>
  );
};

ChatNow.propTypes = {
  chatQueues: PropTypes.shape({
    chat_pending: PropTypes.bool,
    channel_sid: PropTypes.string,
    patient_id: PropTypes.string,
    patient_first_name: PropTypes.string,
    patient_last_name: PropTypes.string
  })
};

export default ChatNow;
